import { combineReducers } from "redux";
import settngReducer from "./reducers/setting/settingReducer";

export const rootReducer = combineReducers({
  setting: settngReducer,
});
